import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import Login from './components/Login';
import CustomerSignup from './components/customer/CustomerSignup';
import ForgotPassword from './components/ForgotPassword';
import CustomerDashboard from './components/customer/CustomerDashboard';
import Dashboard from './components/admin/Dashboard';
import AgencyDashboard from './components/agency/AgencyDashboard';

function App() {
  // Check localStorage for existing authentication state on mount
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const savedAuth = localStorage.getItem('isAuthenticated');
    return savedAuth === 'true';
  });

  const [isCustomerAuthenticated, setIsCustomerAuthenticated] = useState(() => {
    const savedAuth = localStorage.getItem('customerAuthenticated');
    return savedAuth === 'true';
  });

  const [isAgencyAuthenticated, setIsAgencyAuthenticated] = useState(() => {
    const savedAuth = localStorage.getItem('agencyAuthenticated');
    return savedAuth === 'true';
  });

  useEffect(() => {
    // Save authentication state to localStorage whenever it changes
    if (isAuthenticated) {
      localStorage.setItem('isAuthenticated', 'true');
    } else {
      localStorage.removeItem('isAuthenticated');
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (isCustomerAuthenticated) {
      localStorage.setItem('customerAuthenticated', 'true');
    } else {
      localStorage.removeItem('customerAuthenticated');
    }
  }, [isCustomerAuthenticated]);

  useEffect(() => {
    if (isAgencyAuthenticated) {
      localStorage.setItem('agencyAuthenticated', 'true');
    } else {
      localStorage.removeItem('agencyAuthenticated');
    }
  }, [isAgencyAuthenticated]);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
  };

  const handleCustomerLogin = () => {
    setIsCustomerAuthenticated(true);
    localStorage.setItem('customerAuthenticated', 'true');
  };

  const handleAgencyLogin = () => {
    setIsAgencyAuthenticated(true);
    localStorage.setItem('agencyAuthenticated', 'true');
  };

  const handleAgencyLogout = () => {
    setIsAgencyAuthenticated(false);
    localStorage.removeItem('agencyAuthenticated');
  };

  // Protected Route Component for Admin
  const ProtectedRoute = ({ children }) => {
    return isAuthenticated ? children : <Navigate to="/login" replace />;
  };

  // Protected Route Component for Customer
  const CustomerProtectedRoute = ({ children }) => {
    return isCustomerAuthenticated ? children : <Navigate to="/login" replace />;
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route 
            path="/login" 
            element={
              (isAuthenticated || isCustomerAuthenticated || isAgencyAuthenticated) ? (
                isAuthenticated ? (
                  <Navigate to="/dashboard" replace />
                ) : isAgencyAuthenticated ? (
                  <Navigate to="/agency-dashboard" replace />
                ) : (
                  <Navigate to="/truck-search" replace />
                )
              ) : (
                <Login 
                  onAdminLogin={handleLogin} 
                  onCustomerLogin={handleCustomerLogin}
                  onAgencyLogin={handleAgencyLogin}
                />
              )
            } 
          />
          <Route 
            path="/signup" 
            element={
              isCustomerAuthenticated ? (
                <Navigate to="/truck-search" replace />
              ) : (
                <CustomerSignup />
              )
            } 
          />
          <Route 
            path="/forgot-password" 
            element={
              (isAuthenticated || isCustomerAuthenticated || isAgencyAuthenticated) ? (
                isAuthenticated ? (
                  <Navigate to="/dashboard" replace />
                ) : isAgencyAuthenticated ? (
                  <Navigate to="/agency-dashboard" replace />
                ) : (
                  <Navigate to="/truck-search" replace />
                )
              ) : (
                <ForgotPassword />
              )
            } 
          />
          <Route 
            path="/truck-search" 
            element={
              <CustomerDashboard isAuthenticated={isCustomerAuthenticated} onCustomerLogin={handleCustomerLogin} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard onLogout={handleLogout} />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/agency-dashboard" 
            element={
              isAgencyAuthenticated ? (
                <AgencyDashboard onLogout={handleAgencyLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

